let roleOptions = [
	<option value='administrator'>Administrator</option>,
	<option value='manager'>Manager</option>,
	<option value='buyer'>Buyer</option>,
	<option value='officer'>Officer</option>,
	<option value='member'>Member</option>,
];

export default roleOptions;
